import React from "react";
import {
  Modal,
  Pressable,
  SafeAreaView,
  ScrollView,
  Text,
  View,
} from "react-native";
import constants from "@/config/constants";
import styles from "./legalTermsStyle";
import { useGlobal } from "@/Components/Context/globalContext";
import Markdown from "react-native-markdown-display";

const ModalPrivacy = (
  modalVisiblePrivacy: boolean,
  setModalVisiblePrivacy: any,
) => {
  const { textRecurs, projecte, __ } = useGlobal();

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={modalVisiblePrivacy}
      onRequestClose={() => setModalVisiblePrivacy(!modalVisiblePrivacy)}
    >
      <View style={styles.modalContainer}>
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <View
              style={{
                flex: 0,
                flexDirection: "row",
                alignItems: "flex-start",
              }}
            >
              <Text
                style={{
                  color: constants.colorText,
                  fontWeight: "700",
                  fontSize: 24,
                  lineHeight: 28.8,
                }}
              >
                {textRecurs("aviso_privacidad")}
              </Text>
            </View>
            <SafeAreaView style={styles.containerScrollView}>
              <ScrollView style={styles.scrollView}>
                <Markdown>{__(projecte, "avis_privacitat") || " "}</Markdown>
              </ScrollView>
            </SafeAreaView>
            <Pressable
              style={[
                styles.btnDarkGreen,
                { backgroundColor: projecte.color_principal },
              ]}
              onPress={() => setModalVisiblePrivacy(false)}
            >
              <Text style={styles.btnDarkGreenText}>
                {textRecurs("onboarding_aceptar")}
              </Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default ModalPrivacy;
